"use strict";
exports.__esModule = true;
exports.DEFAULT_NOTIFICATIONS = void 0;
/**
 * @internal Intended for internal use - use it on your own risk
 */
exports.DEFAULT_NOTIFICATIONS = {};
//# sourceMappingURL=model.js.map